<script setup>
defineProps({
    message: {
        type: String,
        default: '',
    },
});
</script>

<template>
    <p
        v-if="message"
        class="text-warning mt-1 text-xs"
    >
        {{ message }}
    </p>
</template>
